import { render } from "./listorderreport.vue?vue&type=template&id=2c725a1d&scoped=true"
import script from "./listorderreport.vue?vue&type=script&lang=js"
export * from "./listorderreport.vue?vue&type=script&lang=js"

import "./listorderreport.vue?vue&type=style&index=0&id=2c725a1d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c725a1d"]])

export default __exports__